import axios from "axios";
import $ from "jquery";

const apiUrl = process.env.VUE_APP_API_URL;

const state = {
  tourPackage: {},
  packageActivity: {},
  toursStatistics: {},
  operatorPackages: [],
  unpublishedPackages: [],
  inactivePackages: [],
  publishedOperatorPackages: [],
  allRearrangePackages: [],
};

const getters = {
  toursStatistics(state) {
    return state.toursStatistics;
  },

  tourPackage(state) {
    return state.tourPackage;
  },

  packageActivity(state) {
    return state.packageActivity;
  },

  operatorPackages(state) {
    return state.operatorPackages;
  },

  unpublishedPackages(state) {
    return state.unpublishedPackages;
  },

  inactivePackages(state) {
    return state.inactivePackages;
  },

  publishedOperatorPackages(state) {
    return state.publishedOperatorPackages;
  },

  allRearrangePackages(state) {
    return state.allRearrangePackages;
  },
};

const mutations = {
  setToursStatistics(state, statistics) {
    state.toursStatistics = statistics;
  },

  setOperatorPackages(state, packages) {
    state.operatorPackages = packages;
  },

  setTourPackage(state, tourPackage) {
    state.tourPackage = tourPackage;
  },

  setPackageActivity(state, packageActivity) {
    state.packageActivity = packageActivity;
  },

  setUnpublishedPackages(state, packages) {
    state.unpublishedPackages = packages;
  },

  setInactivePackages(state, packages) {
    state.inactivePackages = packages;
  },

  setPublishedOperatorPackages(state, packages) {
    state.publishedOperatorPackages = packages;
  },

  seAllPackages4Rearrange(state, packages) {
    state.allRearrangePackages = packages;
  },

  deleteOperatorPackage(state, id) {
    let index = state.operatorPackages.findIndex((p) => p.id == id);
    state.operatorPackages.splice(index, 1);
  },

  deleteUnpublishedPackages(state, id) {
    let index = state.unpublishedPackages.findIndex((p) => p.id == id);
    state.unpublishedPackages.splice(index, 1);
  },

  deleteInactivePackages(state, id) {
    let index = state.inactivePackages.findIndex((p) => p.id == id);
    state.inactivePackages.splice(index, 1);
  },
};

const actions = {
  async fetchToursStatistics({ commit, rootState }) {
    const accessToken = rootState.authStore.token;
    const user = rootState.authStore.user;
    const filter = user.role == "operator" ? `?operator=${user.id}` : "";

    await axios
      .get(`${apiUrl}/package/statistics${filter}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setToursStatistics", res.data);
      });
  },

  async fetchOperatorPackages({ commit, rootState }, id) {
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/operator-package/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setOperatorPackages", res.data);
      });
  },

  async fetchPublishedOperatorPackages({ commit, rootState }, id) {
    const accessToken = rootState.authStore.token;

    if (id == "all") {
      await axios
        .get(`${apiUrl}/package/rearrangement`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          commit("seAllPackages4Rearrange", res.data);
        });
    } else {
      await axios
        .get(`${apiUrl}/operator-package/published/${id}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          commit("setPublishedOperatorPackages", res.data);
        });
    }
  },

  async updatePackageStatus({ dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/package/status/update?id=${data.id}&status=${data.status}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        $.alert("status updated successfull");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async publishPackage({ dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/package/publish/update?id=${data.id}&publish=${data.publish}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        $.alert("package published successfull");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async deletePackage({ dispatch, rootState }, id) {
    dispatch("showSpinnerLoading", null, { root: true });

    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${apiUrl}/package/delete?id=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(() => {
        $.alert("package deleted successfull");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async fetchUnpublishedPackages({ commit, rootState }) {
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/package/unpublished`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setUnpublishedPackages", res.data);
      });
  },

  async fetchTourPackage({ commit, rootState }, id) {
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/package/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourPackage", res.data);
      });
  },

  async fetchInactivePackages({ commit, rootState }) {
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/package/inactive`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setInactivePackages", res.data);
      });
  },

  async createPackage({ rootState }, tourPackage) {
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/package/create`, tourPackage, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async uploadTourPhoto({ rootState }, formData) {
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/tour-photo/upload`, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async uploadTourDayPhoto({ rootState }, formData) {
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/tour-photo-day/upload`, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
      // onUploadProgress: function (progressEvent) {
      //   console.log(parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)));
      // }
    });
  },

  async uploadTourGalleryPhoto({ rootState }, formData) {
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/tour-photo-gallery/upload`, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async uploadTourInnerPhoto({ rootState }, formData) {
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/tour-photo-inner/upload`, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async deleteTourPhoto({ rootState }, data) {
    const accessToken = rootState.authStore.token;

    return await axios.delete(`${apiUrl}/tour-photo/delete`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: data,
    });
  },

  async uploadAccommodationPhotoPackage({ rootState }, formData) {
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/package/accom-photo/upload`, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async deleteAccommodationPhoto({ rootState }, data) {
    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${apiUrl}/package/accom-photo/delete`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        data: data,
      })
      .then(() => {
        $.alert("Accommodation image deleted successfully");
      });
  },

  async updatePackage({ rootState }, data) {
    const accessToken = rootState.authStore.token;

    return await axios.put(`${apiUrl}/package/update/${data.id}`, data.tourPackage, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async updatePackageIcon({ dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/package/card-detail/update/${data.id}?showTag=${data.tag}&showDiscountIcon=${data.discount}&showOperatorLogo=${data.logo}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        $.alert("Icon updated successfully");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async updatePackagePosition({ dispatch, rootState }, positions) {
    dispatch("showSpinnerLoading", null, { root: true });

    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/package/position/update`,
        { package: positions },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(function () {
        $("#loader-spinner").fadeOut("slow");
        $.alert("Position updated successfully");
      });
  },

  async updatePackageTag({ dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/package/tag/update?id=${data.id}&tag=${data.tag}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        $.alert("Tag updated successfully");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async updatePackageActivity({ rootState }, data) {
    const accessToken = rootState.authStore.token;

    return await axios.put(`${apiUrl}/package/activity/update/${data.id}`, data.activities, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async fetchPackageActivity({ commit, rootState }, id) {
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/package/activity/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setPackageActivity", res.data);
      });
  },

  async deletePackageActivity({ dispatch, rootState }, id) {
    dispatch("showSpinnerLoading", null, { root: true });

    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${apiUrl}/package/activity/delete?packageId=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(() => {
        $.alert("Package Activities deleted successfull");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
